import { render, staticRenderFns } from "./SignUpComponent.vue?vue&type=template&id=7dffa912&scoped=true"
import script from "./SignUpComponent.vue?vue&type=script&lang=js"
export * from "./SignUpComponent.vue?vue&type=script&lang=js"
import style0 from "./SignUpComponent.vue?vue&type=style&index=0&id=7dffa912&prod&lang=css"
import style1 from "./SignUpComponent.vue?vue&type=style&index=1&id=7dffa912&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dffa912",
  null
  
)

export default component.exports